import scrollEvent from '../../components/fsUtils/scrollEvent';
import Viewports from '../../components/fsUtils/Viewports';
import screenLock from '../../components/fsUtils/screenLock';

class ScoreStrip {
    constructor() {
        this.mobileMenuBtn = document.getElementById('nav-open-btn');
        this.menu = document.getElementById(this.mobileMenuBtn.dataset.target);
        this.bodyClassList = document.body.classList;
        this.headerWrapper = document.getElementById('header-wrapper');
        this.secondNav = document.querySelector('.section-nav');
        this.globalNav = document.getElementById('global-nav');
        this.globalNavWrapper = document.getElementsByClassName('global-nav-wrapper')[0];
        this.globalNavOverlay = document.getElementById('global-nav-overlay');
        this.globalNavDefault = document.querySelector('#sports-nav .menu-title');
        this.globalNavContainer = document.querySelector('.global-nav-container');
        this.globalNavHeight = this.globalNavContainer.offsetHeight || 0;
        this.scoreStripButton = document.getElementById('ScoresLink');
        this.scoreStripContainer = document.getElementById('ScorestripContainer');
        this.scoreStripContainerBG = document.getElementById('scorestripContainerBG');
        this.mActivator = document.querySelector('.m-nav-activator');
        this.topLevel = document.querySelector('.section-nav .top-level');
        this.throttle = ('ontouchstart' in document.documentElement) ? 500 : 250;
        this.branchBannerHeight = 76;

        this.viewport = new Viewports({
            'mobile': 767,
            'desktop': 1024
        });
        this.screenLock = new screenLock();
        this.setScoreStripViewportClassname();

        if (this.scoreStripButton !== null) { 
            this.attachScoresBtnClick(); 
        }
    }

    init() {

        if (this.scoreStripButton !== null) {            

            this.watchResize = this.watchResize.bind(this);
            this.watchResize = scrollEvent.throttle(this.watchResize, this.throttle);
            window.addEventListener('resize', this.watchResize);

            this.setScoreStripViewportClassname();
        }
    }
    attachScoresBtnClick(){
        let that = this;
        that.scoreStripButton.addEventListener('click', (ev) => {
            if (window.scoreStrip) {
                that.toggleScorestrip( that.scoreStripButton.getAttribute('data-sport'), that.scoreStripButton.getAttribute('data-group-id') );

                if (ev.preventDefault) ev.preventDefault();
                return false;
            }
            return;
        });
    }
    setScoreStripViewportClassname() {

        if (this.viewport.getViewPort() === 'mobile') {
            this.bodyClassList.add('scorestrip-tall');
            this.bodyClassList.remove('scorestrip-wide');
        } else {
            this.bodyClassList.add('scorestrip-wide');
            this.bodyClassList.remove('scorestrip-tall');
        }
    }

    open() {
        if (this.bodyClassList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
            window.scrollTo(0, this.branchBannerHeight);
        }
        this.globalNavContainerTopPos = this.globalNavContainer.getBoundingClientRect().top || 0;
        this.screenLock.lockScreen();

        this.bodyClassList.add('scorestrip-open');

        //close second nav if opened
        if (document.body.classList.contains('section-menu-open')) {
            this.mActivator.classList.remove('is-active');
            this.topLevel.classList.remove('is-active');
            document.body.classList.remove('section-menu-open');
        }

        // close global nav if open
        if (this.mobileMenuBtn.classList.contains('active')) {
            this.mobileMenuBtn.classList.remove('active');
            this.menu.classList.remove('active');
            this.bodyClassList.remove('global-menu-open');
            this.globalNavOverlay.classList.remove('show');
            this.globalNavWrapper.classList.remove('show');
            this.globalNavDefault.classList.remove('active');
        }

        if (window.scoreStrip) window.scoreStrip.maximize();
    }

    shut() {
        if (this.viewport.getViewPort() === 'tablet' || this.bodyClassList.contains('branch-banner-is-active')) {
            this.globalNavWrapper.style.top = null;
            this.headerWrapper.style.top = null;
        }
        this.bodyClassList.remove('scorestrip-open');
        this.screenLock.unlockScreen();
        if (window.scoreStrip) window.scoreStrip.minimize();
    }

    toggleScorestrip(sport = '',groupId = '') {
        if (window.scoreStrip) {
            if( this.scoreStripContainer === null ) {
                this.createScoreStrip( sport, groupId );                
            }
            if (this.bodyClassList.contains('scorestrip-open')) {
                this.shut();
            } else {
                this.open();
            }
        }
    }

    watchResize() {
        this.viewport.setWinW(window.innerWidth);
        this.setScoreStripViewportClassname();
        
        if (this.bodyClassList.contains('scorestrip-open')) {
            if (this.viewport.getViewPort() !== 'mobile' && window.scoreStrip) this.shut();
        }
    }

    createScoreStrip(sport = '',groupId = ''){
        let bhw = document.getElementById('body-header-wrapper');
        let hw = document.getElementById('header-wrapper');
        let scorestripTemplate = `<div id="scorestripContainerBG" class="scorestripContainerBG"></div>
                    <div class="scorestrip-tablet-disabled scorestrip-desktop-disabled">
                        <wis-scorestrip
                                sport="${sport}"
                                groupId="${groupId}"></wis-scorestrip>
                    </div>`;
        let scorestripContainer = document.createElement('div');
        scorestripContainer.setAttribute('id','ScorestripContainer');
        scorestripContainer.setAttribute('class','scorestripContainer');
        scorestripContainer.innerHTML = scorestripTemplate;
        bhw.insertBefore(scorestripContainer,hw);

        this.scoreStripContainer = document.getElementById('ScorestripContainer');
        this.scoreStripContainerBG = document.getElementById('scorestripContainerBG');
        this.bodyClassList.remove('no-scorestrip');

        this.init();
    }

}

export default ScoreStrip;



// WEBPACK FOOTER //
// ./assets/components/scorestrip/scorestrip.js